/**
 * Error model for the standalone file-import feature.
 *
 * Discriminated union: `network` / `api` transport failures come from the
 * app-wide `@/utils/infra-error` classifier; `validation` carries field-level
 * messages produced by `validateForAnalyze`. Pure and framework-free.
 */
import { classifyInfraError, type InfraFailure } from '@/utils/infra-error';

export type FileImportError =
  | InfraFailure
  | { kind: 'validation'; fields: Record<string, string> };

/**
 * Map an infrastructure error into a `FileImportError`. Only ever yields a
 * `network` / `api` failure; `validation` is produced directly by the domain.
 * `defaultMessage` names the failing step (parse / analyze / import) and is
 * used only when the error carries no usable message of its own.
 */
export function toFileImportError(e: unknown, defaultMessage: string): FileImportError {
  return classifyInfraError(e, defaultMessage);
}
